import {
    IonApp,
    IonIcon,
    IonLabel,
    IonRouterOutlet,
    IonTabBar,
    IonTabButton,
    IonTabs,
    setupIonicReact
} from '@ionic/react';
import { IonSpinner } from '@ionic/react';
import { IonReactRouter } from "@ionic/react-router";
import { information, mapOutline, search } from "ionicons/icons"; // Importamos el icono de logout
import Tab1 from "./tabs/Tab1";
import Tab2 from "./tabs/Tab2";
import Tab3 from "./tabs/Tab3";
import { Route } from "react-router-dom";
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import './theme/variables.css';

setupIonicReact();

const App = () => {
    const { t, ready } = useTranslation();


    if (!ready) {
        return <IonSpinner />; // retorna un spinner de carga
    }

    return (
        <IonApp>
            <IonReactRouter>
                <IonTabs>
                    <IonRouterOutlet>
                        <Route path="/" component={Tab1} exact={true} />
                        <Route path="/search" component={Tab2} exact={true} />
                        <Route path="/info" component={Tab3} exact={true} />
                    </IonRouterOutlet>

                    <IonTabBar slot="bottom" style={{ paddingBottom: '20px' }}>
                        <IonTabButton tab="map" href="/">
                            <IonIcon icon={mapOutline} />
                            <IonLabel>
                                {t('tabs.map')}
                            </IonLabel>
                        </IonTabButton>

                        <IonTabButton tab="search" href="/search">
                            <IonIcon icon={search} />
                            <IonLabel>
                                {t('tabs.search')}
                            </IonLabel>
                        </IonTabButton>

                        <IonTabButton tab="info" href="/info">
                            <IonIcon icon={information} />
                            <IonLabel>
                                {t('tabs.info')}
                            </IonLabel>
                        </IonTabButton>
                    </IonTabBar>
                </IonTabs>
            </IonReactRouter>
        </IonApp>
    );
};

export default function WrappedApp() {
    return (
        <Suspense fallback={
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <IonSpinner />
            </div>
        }>
            <App />
        </Suspense>
    );
}
